export const ProjectStatus = {
    "PROJECT_CREATED_BY_ADMIN": '1',
    "PROJECT_IN_PROGRESS": '2',
    "PROJECT_CANCELLED": '3',
    "PROJECT_CLOSED_BY_ADMIN": '4',
    "CUSTOMER_APPROVE_CANCELLATION": "5",
    "PROJECT_CANCELLED_BY_CUSTOMER": '6'
}